export default function(can, cannot) {
  // property
  can('view', 'Property');
  cannot('edit', 'Property');
  cannot('add', 'Property');
  can('bulk-edit', 'Property');
  can('list', 'Property');
  can('change-incharge', 'Property');
  // repair content of property
  can('list', 'PropertyRepairContent');
  cannot('edit', 'PropertyRepairContent');
  can('view', 'PropertyRepairContent');
  can('list', 'RepairContentHistory');
  // repair content
  can('view', 'RepairContent');

  can('view', 'ContractMoving');
  can('edit', 'ContractMoving');
  can('add', 'ContractMoving');
  can('list', 'ContractMoving');

  // move out
  can('view', 'ContractMoveOut');
  can('edit', 'ContractMoveOut');
  can('add', 'ContractMoveOut');

  // account
  can('view', 'Account');
  can('add', 'Account');
  can('edit', 'Account');
  can('list', 'Account');
  can('link', 'Account');

  // company
  can('view-info', 'Company');

  // moveout follow
  can('move-out-follow', 'ContractMoving');

  // Dashboard
  can('view', 'Dashboard');

  // MyPage
  can('view', 'MyPage');

  // MyPage
  can('list', 'Message');

  // side bar
  can('view-menu', 'Dashboard');
  can('view-menu', 'Company');
  can('view-menu', 'Account');
  can('view-menu', 'Property');
  can('view-menu', 'Account');
  can('view-menu', 'TalkRoom');
  can('view-menu', 'ContractMoving');
}
